/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- ADD-ON TYPES COMMUNITY TOP ARTICLES: STYLES --------------- ++++++++++ */
export default theme => ({
    toparticles: {
        '& .sectioncontent': {
            display: 'flex',
            flexFlow: 'row wrap',
            width: '100%',
            '& .control': {
                minWidth: pxToEm(64),
                maxWidth: pxToEm(64),
                flex: 1,
                flexBasis: '20%',
                marginBottom: pxToEm(8),
                marginRight: pxToEm(8),
                boxShadow: 'none',
                '&.selected-true': {
                    background: 'rgba(129, 201, 255, 0.09)'
                }
            }
        }
    }
});
